/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BidderDto } from '../../models/bidder-dto';

export interface GetBidder$Params {
  id: number;
  'X-API-Version'?: string;
}

export function getBidder(http: HttpClient, rootUrl: string, params: GetBidder$Params, context?: HttpContext): Observable<StrictHttpResponse<BidderDto>> {
  const rb = new RequestBuilder(rootUrl, getBidder.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.header('X-API-Version', params['X-API-Version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BidderDto>;
    })
  );
}

getBidder.PATH = '/api/bidders/{id}';
